import { NarrowingStep } from './types';

/**
 * The part request as the answers so far refined it: "Door" → "Door, Front"
 * → "Door, Front, Left". A section answer names the part itself ("Filter" →
 * "Engine oil filter"), so it replaces the base. "Both" and "Show diagram"
 * refine nothing.
 */
export const refinedRequestLabel = (base: string, trail?: NarrowingStep[] | null): string => {
  const steps = (trail || []).filter(s => s.to < s.from && s.value !== 'both');
  const section = [...steps].reverse().find(s => s.axis === 'section');
  const head = (section ? section.label : base || '').trim();
  const words = steps
    .filter(s => s.axis !== 'section')
    .map(s => s.label.trim())
    .filter(w => w && !head.toLowerCase().includes(w.toLowerCase()));
  return [head, ...words].filter(Boolean).join(', ');
};
